import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { GlobalService } from '../global.service';


@Injectable({
  providedIn: 'root'
})
export class PermissionService implements CanActivate {
  constructor(private router:Router,public global:GlobalService){}
  canActivate(route: ActivatedRouteSnapshot,state: RouterStateSnapshot):  boolean {
    return true// this.global.screenEnabled;
  } 
}